<div
  class="
    bets-card
    tw-w-full
    tw-flex
    tw-flex-col
  "
>

  <!-- "My Bets" pill header -->
  <!-- @if (!hideTitle) { -->
    <div
      class="
        bets-tab-strip
        tw-flex
      "
    >
      <div
        class="
          bets-tab-pill
          tw-relative
          tw-bottom-[-11px]
          tw-z-[-1]
          tw-capitalize
          tw-w-[137px]
          tw-bg-[#769ED1]
          tw-text-center
          tw-text-[18px]
          tw-text-[#FFFFFF]
          tw-rounded-[4px]
          tw-pt-[5px]
          tw-pb-[12px]
          tw-px-[5px]
        "
      >
        {{ 'ui.wager.my.bets' | translate: 'My Bets' }}
      </div>
    </div>
  <!-- } -->

  <!-- Body: filter chip row + tree table -->
  <!-- [class.has-title]="!hideTitle" -->
  <div
    class="
      bets-body
      tw-bg-[#EDF1F5]
      tw-rounded-[13px]
      tw-p-[10px]
    "
  >

    <!-- Saved / Active / Closed filter chips -->
    <div class="bets-filter-row tw-flex tw-gap-[8px]">
      <button
        type="button"
        (click)="savedTab()"
        [class.tw-bg-[#C7C7C6]]="showSavedBets"
        class="
          bets-filter-chip
          tw-bg-[#19385D]
          tw-font-normal
          tw-text-[#FFFFFF]
          tw-text-[18px]
          tw-px-[12px]
          tw-py-[4px]
          tw-rounded-[4px]
          tw-cursor-pointer
        "
        data-cy="bets-saved-tab"
      >
        {{ 'betsummary.stackedbets' | translate: 'Saved Bets' }}
      </button>
      <button
        type="button"
        (click)="activeTab()"
        [class.tw-bg-[#C7C7C6]]="showActiveBets"
        class="
          bets-filter-chip
          tw-bg-[#19385D]
          tw-font-normal
          tw-text-[#FFFFFF]
          tw-text-[18px]
          tw-px-[12px]
          tw-py-[4px]
          tw-rounded-[4px]
          tw-cursor-pointer
        "
        data-cy="bets-active-tab"
      >
        {{ 'betsummary.activebets' | translate: 'Active Bets' }}
      </button>
      <button
        type="button"
        (click)="closedTab()"
        [class.tw-bg-[#C7C7C6]]="showClosedBets"
        class="
          bets-filter-chip
          tw-bg-[#19385D]
          tw-font-normal
          tw-text-[#FFFFFF]
          tw-text-[18px]
          tw-px-[12px]
          tw-py-[4px]
          tw-rounded-[4px]
          tw-cursor-pointer
        "
        data-cy="bets-closed-tab"
      >
        {{ 'wager.closedbets' | translate: 'Closed Bets' }}
      </button>
    </div>

    <!-- Tree table -->
    <div
      class="
        bets-tree
        tw-flex
        tw-flex-col
        tw-mt-[5px]
      "
      data-cy="bets-tree"
    >

      <!-- Grand Total row (always visible) -->
      <!--
        Grand Total is the "first row" of the tree table, so it carries
        all four borders in #7C8FCC. Every subsequent row (event / race /
        ticket / empty state) only draws left + right + bottom borders so
        adjacent rows share a single divider line (avoids doubling: the
        previous row's border-bottom is the next row's visual top).
      -->
      <div
        class="
          bets-row
          bets-row--grand-total
          tw-grid
          tw-grid-cols-[28px_minmax(0,_1fr)_90px_80px_auto]
          tw-items-center
          tw-gap-[8px]
          tw-p-[6px_10px]
          tw-border-t tw-border-t-[#7C8FCC]
          tw-border-l tw-border-l-[#7C8FCC]
          tw-border-r tw-border-r-[#7C8FCC]
          tw-border-b tw-border-b-[#7C8FCC]
        "
        data-cy="bets-grand-total-row"
      >
        <button
          type="button"
          class="
            bets-chevron
            tw-bg-transparent
            tw-border-0
            tw-p-0
            tw-w-[24px]
            tw-h-[24px]
            tw-flex
            tw-items-center
            tw-justify-center
            tw-cursor-pointer
            tw-text-[#1B478A]
            tw-transition-colors tw-duration-[120ms] tw-ease-in-out
          "
          (click)="toggleGrandTotal()"
          [attr.aria-expanded]="isGrandTotalExpanded"
          [attr.aria-label]="isGrandTotalExpanded ? 'Collapse grand total' : 'Expand grand total'"
        >
          <mat-icon
            class="
              bets-chevron-icon
              !tw-text-[#1C1C1C]
              !tw-text-[18px]
              !tw-w-[18px]
              !tw-h-[18px]
              !tw-leading-none
              !tw-flex
              !tw-items-center
              !tw-justify-center
            "
          >
            {{ isGrandTotalExpanded ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>

        <div
          class="
            bets-row-label
            tw-text-[13px]
            tw-text-[#000000]
            tw-font-semibold
            tw-min-w-0
            tw-whitespace-nowrap
            tw-overflow-hidden
            tw-text-ellipsis
          "
          data-cy="bets-grand-total-label"
        >
          {{ 'wager.grandtotal' | translate: 'Grand Total' }}
        </div>

        <div
          class="
            bets-row-count
            tw-text-[12px]
            tw-text-[#000000]
            tw-font-semibold
            tw-text-left
            tw-whitespace-nowrap
          "
          data-cy="bets-grand-total-count"
        >
          {{ grouped.grandTotalCount || 0 }}
          {{ (grouped.grandTotalCount === 1) ? ('ui.wager.ticket' | translate: 'Ticket') : ('generic.tickets' | translate: 'Tickets') }}
        </div>

        <div
          class="
            bets-row-amount
            tw-text-[13px]
            tw-text-[#000000]
            tw-font-bold
            tw-text-right
            tw-whitespace-nowrap
          "
          data-cy="bets-grand-total-amount"
        >
          ${{ (grouped.grandTotalAmount || 0) | number:'1.2-2' }}
        </div>

        <!-- Aggregation row buttons are visual-only (disabled).
             Click handling lives on the leaf ticket row so the
             bulk-action semantics stay explicit / opt-in. -->
        <div
          class="
            bets-row-actions
            tw-inline-flex
            tw-items-center
            tw-gap-[6px]
            tw-justify-end
            tw-min-h-[26px]
          "
        >
          <!-- Hide Cancel on active tab; only Remove on saved -->
          @if (currentTab === 'saved') {
            <button
              type="button"
              [class.tw-mr-[5px]]="currentTab === 'saved'"
              class="
                bets-btn
                bets-btn--remove
                tw-inline-flex
                tw-items-center
                tw-justify-center
                tw-border-0
                tw-rounded-[4px]
                tw-text-[11px]
                tw-font-semibold
                tw-tracking-[0.2px]
                tw-py-[4px]
                tw-cursor-pointer
                tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                tw-whitespace-nowrap
                tw-w-[80px]
                tw-h-[26px]
                tw-flex-[0_0_80px]
                tw-text-[#FFFFFF]
              "
              (click)="confirmBet('remove-saved-bet', 'grand-total', grouped)"
              data-cy="bets-grand-total-remove"
            >
              {{ 'generic.remove' | translate: 'Remove' }}
            </button>
          }
          @if (currentTab === 'saved') {
            <button
              type="button"
              class="
                bets-btn
                bets-btn--submit
                tw-inline-flex
                tw-items-center
                tw-justify-center
                tw-border-0
                tw-rounded-[4px]
                tw-text-[11px]
                tw-font-semibold
                tw-tracking-[0.2px]
                tw-py-[4px]
                tw-cursor-pointer
                tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                tw-whitespace-nowrap
                tw-w-[80px]
                tw-h-[26px]
                tw-flex-[0_0_80px]
                tw-text-[#FFFFFF]
              "
              (click)="confirmBet('submit-saved-bet', 'grand-total', grouped)"
              data-cy="bets-grand-total-submit"
            >
              {{ 'generic.submit' | translate: 'Submit' }}
            </button>
          }
        </div>
      </div>

      <!-- Empty state shown when the tree has no entries for the active tab -->
      @if (isGrandTotalExpanded && grouped.events.length === 0) {
        <div
          class="
            bets-empty
            tw-p-[20px_14px]
            tw-text-center
            tw-text-[13px]
            tw-text-[#000000]
            tw-border-l tw-border-l-[#7C8FCC]
            tw-border-r tw-border-r-[#7C8FCC]
            tw-border-b tw-border-b-[#7C8FCC]
          "
          data-cy="bets-empty"
        >
          @if (currentTab === 'saved') {
            {{ 'ui.wager.you.have.no.saved.bets' | translate: 'You have no saved bets.' }}
          } @else if (currentTab === 'closed') {
            {{ 'ui.wager.you.have.no.closed.bets' | translate: 'You have no closed bets.' }}
          } @else {
            {{ 'ui.wager.you.have.no.active.bets' | translate: 'You have no active bets.' }}
          }
        </div>
      }

      <!-- Event groups -->
      <!--
        Limit the visible track list to ~5 rows so the My Bets card
        never pushes the rest of the wager page below the fold. Beyond
        five tracks a slim themed scrollbar (see `.bets-events-scroll`
        in the .scss) appears so the user can scroll up / down to find
        the rest of their bets. When there are fewer than 5 tracks the
        wrapper collapses to fit its content — no empty whitespace.
      -->
      @if (isGrandTotalExpanded) {
        <div
          class="bets-events-scroll"
          data-cy="bets-events-scroll"
        >
        <ng-container *ngFor="let event of grouped.events; let eIdx = index">
          <div
            class="
              bets-row
              bets-row--event
              tw-grid
              tw-grid-cols-[28px_minmax(0,_1fr)_90px_80px_auto]
              tw-items-center
              tw-gap-[8px]
              tw-p-[6px_10px]
              tw-bg-[#FFFFFF]
              tw-border-l tw-border-l-[#7C8FCC]
              tw-border-r tw-border-r-[#7C8FCC]
              tw-border-b tw-border-b-[#7C8FCC]
            "
            [attr.data-cy]="'bets-event-row-' + eIdx"
          >
            <button
              type="button"
              class="
                bets-chevron
                tw-bg-transparent
                tw-border-0
                tw-p-0
                tw-w-[24px]
                tw-h-[24px]
                tw-flex
                tw-items-center
                tw-justify-center
                tw-cursor-pointer
                tw-text-[#1B478A]
                tw-transition-colors tw-duration-[120ms] tw-ease-in-out
              "
              (click)="toggleEvent(event.eventId)"
              [attr.aria-expanded]="isEventExpanded(event.eventId)"
              [attr.aria-label]="isEventExpanded(event.eventId) ?
                'Collapse ' + event.eventName : 'Expand ' + event.eventName"
            >
              <mat-icon
                class="
                  bets-chevron-icon
                  !tw-text-[#1C1C1C]
                  !tw-text-[18px]
                  !tw-w-[18px]
                  !tw-h-[18px]
                  !tw-leading-none
                  !tw-flex
                  !tw-items-center
                  !tw-justify-center
                "
              >
                {{ isEventExpanded(event.eventId) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>

            <div
              class="
                bets-row-label
                tw-text-[13px]
                tw-text-[#000000]
                tw-min-w-0
                tw-whitespace-nowrap
                tw-overflow-hidden
                tw-text-ellipsis
              "
              [attr.data-cy]="'bets-event-name-' + eIdx"
            >
              {{ event.eventName }}
            </div>

            <div
              class="
                bets-row-count
                tw-text-[12px]
                tw-text-[#000000]
                tw-text-left
                tw-whitespace-nowrap
              "
              [attr.data-cy]="'bets-event-count-' + eIdx"
            >
              {{ event.ticketCount }} {{ event.ticketCount === 1 ? ('ui.wager.ticket' | translate: 'Ticket') : ('generic.tickets' | translate: 'Tickets') }}
            </div>

            <div
              class="
                bets-row-amount
                tw-text-[13px]
                tw-text-[#000000]
                tw-text-right
                tw-whitespace-nowrap
              "
              [attr.data-cy]="'bets-event-amount-' + eIdx"
            >
              ${{ event.totalAmount | number:'1.2-2' }}
            </div>

            <div
              class="
                bets-row-actions
                tw-inline-flex
                tw-items-center
                tw-gap-[6px]
                tw-justify-end
                tw-min-h-[26px]
              "
            >
              <!-- Hide Cancel on active tab; only Remove on saved -->
              @if (currentTab === 'saved') {
                <button
                  type="button"
                  [class.tw-mr-[5px]]="currentTab === 'saved'"
                  class="
                    bets-btn
                    bets-btn--remove
                    tw-inline-flex
                    tw-items-center
                    tw-justify-center
                    tw-border-0
                    tw-rounded-[4px]
                    tw-text-[11px]
                    tw-font-semibold
                    tw-tracking-[0.2px]
                    tw-py-[4px]
                    tw-cursor-pointer
                    tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                    tw-whitespace-nowrap
                    tw-w-[80px]
                tw-h-[26px]
                tw-flex-[0_0_80px]
                    tw-text-[#FFFFFF]
                  "
                  (click)="confirmBet('remove-saved-bet', 'event', event)"
                  [attr.data-cy]="'bets-event-remove-' + eIdx"
                >
                  {{ 'generic.remove' | translate: 'Remove' }}
                </button>
              }
              @if (currentTab === 'saved') {
                <button
                  type="button"
                  class="
                    bets-btn
                    bets-btn--submit
                    tw-inline-flex
                    tw-items-center
                    tw-justify-center
                    tw-border-0
                    tw-rounded-[4px]
                    tw-text-[11px]
                    tw-font-semibold
                    tw-tracking-[0.2px]
                    tw-py-[4px]
                    tw-cursor-pointer
                    tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                    tw-whitespace-nowrap
                    tw-w-[80px]
                tw-h-[26px]
                tw-flex-[0_0_80px]
                    tw-text-[#FFFFFF]
                  "
                  (click)="confirmBet('submit-saved-bet', 'event', event)"
                  [attr.data-cy]="'bets-event-submit-' + eIdx"
                >
                  {{ 'generic.submit' | translate: 'Submit' }}
                </button>
              }
            </div>
          </div>

          <!-- Race groups inside the event -->
          @if (isEventExpanded(event.eventId)) {
            <ng-container *ngFor="let race of event.races; let rIdx = index">
              <div
                class="
                  bets-row
                  bets-row--race
                  tw-grid
                  tw-grid-cols-[28px_minmax(0,_1fr)_90px_80px_auto]
                  tw-items-center
                  tw-gap-[8px]
                  tw-p-[6px_10px]
                  tw-bg-[#FFFFFF]
                  tw-border-l tw-border-l-[#7C8FCC]
                  tw-border-r tw-border-r-[#7C8FCC]
                  tw-border-b tw-border-b-[#7C8FCC]
                "
                [attr.data-cy]="'bets-race-row-' + eIdx + '-' + rIdx"
              >
                <button
                  type="button"
                  class="
                    bets-chevron
                    tw-bg-transparent
                    tw-border-0
                    tw-p-0
                    tw-w-[24px]
                    tw-h-[24px]
                    tw-flex
                    tw-items-center
                    tw-justify-center
                    tw-cursor-pointer
                    tw-text-[#1B478A]
                    tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                  "
                  (click)="toggleRace(race.raceKey)"
                  [attr.aria-expanded]="isRaceExpanded(race.raceKey)"
                  [attr.aria-label]="isRaceExpanded(race.raceKey)
                    ? ('ui.wager.collapse.race' | translate: '' : { number: race.raceId })
                    : ('ui.wager.expand.race' | translate: '' : { number: race.raceId })"
                >
                  <mat-icon
                    class="
                      bets-chevron-icon
                      !tw-text-[#1C1C1C]
                      !tw-text-[18px]
                      !tw-w-[18px]
                      !tw-h-[18px]
                      !tw-leading-none
                      !tw-flex
                      !tw-items-center
                      !tw-justify-center
                    "
                  >
                    {{ isRaceExpanded(race.raceKey) ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                </button>

                <div
                  class="
                    bets-row-label
                    tw-text-[13px]
                    tw-text-[#000000]
                    tw-min-w-0
                    tw-whitespace-nowrap
                    tw-overflow-hidden
                    tw-text-ellipsis
                  "
                  [attr.data-cy]="'bets-race-label-' + eIdx + '-' + rIdx"
                >
                  <span
                    class="
                      race-name
                    "
                  >
                    {{ 'generic.race' | translate: 'Race' }} {{ race.raceId }}
                  </span>
                  @if (race.postTime) {
                    <span
                      class="
                        race-post-time
                        tw-ml-[14px]
                        tw-text-[#000000]
                      "
                    >
                      {{ race.postTime + 'Z' | date:'shortTime' }}
                    </span>
                  }
                </div>

                <div
                  class="
                    bets-row-count
                    tw-text-[12px]
                    tw-text-[#000000]
                    tw-text-left
                    tw-whitespace-nowrap
                  "
                  [attr.data-cy]="'bets-race-count-' + eIdx + '-' + rIdx"
                >
                  {{ race.ticketCount }} {{ race.ticketCount === 1 ? ('ui.wager.ticket' | translate: 'Ticket') : ('generic.tickets' | translate: 'Tickets') }}
                </div>

                <div
                  class="
                    bets-row-amount
                    tw-text-[13px]
                    tw-text-[#000000]
                    tw-text-right
                    tw-whitespace-nowrap
                  "
                  [attr.data-cy]="'bets-race-amount-' + eIdx + '-' + rIdx"
                >
                  ${{ race.totalAmount | number:'1.2-2' }}
                </div>

                <div
                  class="
                    bets-row-actions
                    tw-inline-flex
                    tw-items-center
                    tw-gap-[6px]
                    tw-justify-end
                    tw-min-h-[26px]
                  "
                >
                  <!-- Hide Cancel on active tab; only Remove on saved -->
                  @if (currentTab === 'saved') {
                    <button
                      type="button"
                      [class.tw-mr-[5px]]="currentTab === 'saved'"
                      class="
                        bets-btn
                        bets-btn--remove
                        tw-inline-flex
                        tw-items-center
                        tw-justify-center
                        tw-border-0
                        tw-rounded-[4px]
                        tw-text-[11px]
                        tw-font-semibold
                        tw-tracking-[0.2px]
                        tw-py-[4px]
                        tw-cursor-pointer
                        tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                        tw-whitespace-nowrap
                        tw-w-[80px]
                        tw-h-[26px]
                        tw-flex-[0_0_80px]
                        tw-text-[#FFFFFF]
                      "
                      (click)="confirmBet('remove-saved-bet', 'race', race)"
                      [attr.data-cy]="'bets-race-remove-' + eIdx + '-' + rIdx"
                    >
                      {{ 'generic.remove' | translate: 'Remove' }}
                    </button>
                  }
                  @if (currentTab === 'saved') {
                    <button
                      type="button"
                      class="
                        bets-btn
                        bets-btn--submit
                        tw-inline-flex
                        tw-items-center
                        tw-justify-center
                        tw-border-0
                        tw-rounded-[4px]
                        tw-text-[11px]
                        tw-font-semibold
                        tw-tracking-[0.2px]
                        tw-py-[4px]
                        tw-cursor-pointer
                        tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                        tw-whitespace-nowrap
                        tw-w-[80px]
                        tw-h-[26px]
                        tw-flex-[0_0_80px]
                        tw-text-[#FFFFFF]
                      "
                      (click)="confirmBet('submit-saved-bet', 'race', race)"
                      [attr.data-cy]="'bets-race-submit-' + eIdx + '-' + rIdx"
                    >
                      {{ 'generic.submit' | translate: 'Submit' }}
                    </button>
                  }
                </div>
              </div>

              <!-- Individual tickets inside the race -->
              @if (isRaceExpanded(race.raceKey)) {
                <ng-container *ngFor="let ticket of race.tickets; let tIdx = index">
                  <!-- Previous grid. The third track was a fixed 90px count
                       column that only ever holds content on the Closed tab,
                       so it reserved dead space on Saved/Active. It is now
                       auto, which measures 0 when the cell is empty:
                       tw-grid-cols-[28px_minmax(0,_1fr)_90px_80px_auto] -->
                  <div
                    class="
                      bets-row
                      bets-row--ticket
                      tw-grid
                      tw-grid-cols-[28px_minmax(0,_1fr)_auto_80px_auto]
                      tw-items-center
                      tw-gap-[8px]
                      tw-p-[6px_10px]
                      tw-bg-[#FFFFFF]
                      tw-border-l tw-border-l-[#7C8FCC]
                      tw-border-r tw-border-r-[#7C8FCC]
                      tw-border-b tw-border-b-[#7C8FCC]
                    "
                    [class.cancelled]="ticket.IsCancelled"
                    [attr.data-cy]="'bets-ticket-row-' + eIdx + '-' + rIdx + '-' + tIdx"
                  >
                    <div
                      class="
                        bets-chevron
                        bets-chevron--leaf
                        tw-bg-transparent
                        tw-border-0
                        tw-p-0
                        tw-w-[24px]
                        tw-h-[24px]
                        tw-flex
                        tw-items-center
                        tw-justify-center
                        tw-cursor-pointer
                        tw-text-[#1B478A]
                        tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                      "
                      aria-hidden="true"
                    >
                      <span
                        class="
                          bets-leaf-badge
                          tw-inline-flex
                          tw-items-center
                          tw-justify-center
                          tw-w-[18px]
                          tw-h-[18px]
                          tw-rounded-[4px]
                          tw-bg-[#4D8FE5]
                          tw-text-[#FFFFFF]
                          tw-text-[11px]
                          tw-font-bold
                          tw-leading-none
                        "
                      >
                        R
                      </span>
                    </div>

                    <!-- Previous details cell. It clipped the bet legs to an
                         ellipsis, so a multi-leg line could not be read back:
                         tw-whitespace-nowrap
                         tw-overflow-hidden
                         tw-text-ellipsis
                         and the body was toTicketDetailsLine(ticket) -->
                    <div
                      class="
                        bets-row-label
                        bets-ticket-details
                        tw-text-[13px]
                        tw-text-[#000000]
                        tw-min-w-0
                        tw-whitespace-normal
                        tw-break-words
                        tw-leading-[1.35]
                      "
                      [class.tw-line-through]="ticket.IsCancelled"
                      [title]="toTicketDetailsLine(ticket)"
                      [attr.data-cy]="'bets-ticket-details-' + eIdx + '-' + rIdx + '-' + tIdx"
                    >
                      {{ toWrappableTicketDetailsLine(ticket) }}
                    </div>

                    <div
                      class="
                        bets-row-count
                        bets-ticket-count
                        tw-text-[#036E23]
                        tw-font-semibold
                      "

                      [attr.data-cy]="'bets-ticket-count-' + eIdx + '-' + rIdx + '-' + tIdx"
                    >
                      @if (currentTab === 'closed' && hasPositiveNetPayoff(ticket)) {
                        <!-- The 90px the grid track used to reserve now lives
                             here as a min-width, so Pay still lines up with the
                             counts above it but a long payout can widen the
                             track instead of spilling into the amount column -->
                        <span
                          class="
                            bets-pay-net-off
                            tw-inline-block
                            tw-min-w-[90px]
                            tw-text-[#036E23]
                            tw-font-bold
                          "
                        >
                        {{
                          'ui.wager.pay.amount'
                            | translate: '' : { amount: (ticket.NetPayoff | number: '1.2-2') }
                        }}
                        </span>
                      }
                    </div>

                    <div
                      class="
                        bets-row-amount
                        tw-text-[13px]
                        tw-text-[#000000]
                        tw-text-right
                        tw-whitespace-nowrap
                      "
                      [class.tw-line-through]="ticket.IsCancelled"
                      [attr.data-cy]="'bets-ticket-amount-' + eIdx + '-' + rIdx + '-' + tIdx"
                    >
                      ${{ ticket.TicketAmount | number:'1.2-2' }}
                    </div>

                    <div
                      class="
                        bets-row-actions
                        tw-inline-flex
                        tw-items-center
                        tw-gap-[6px]
                        tw-justify-end
                        tw-min-h-[26px]
                      "
                    >
                      @if (currentTab === 'saved') {
                        <button
                          type="button"
                          class="
                            bets-btn
                            bets-btn--remove
                            tw-inline-flex
                            tw-items-center
                            tw-justify-center
                            tw-border-0
                            tw-rounded-[4px]
                            tw-text-[11px]
                            tw-font-semibold
                            tw-tracking-[0.2px]
                            tw-py-[4px]
                            tw-cursor-pointer
                            tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                            tw-whitespace-nowrap
                            tw-w-[80px]
                            tw-h-[26px]
                            tw-flex-[0_0_80px]
                            tw-text-[#FFFFFF]
                            tw-mr-[5px]
                          "
                          (click)="confirmBet('remove-saved-bet', 'ticket', ticket)"
                          [attr.data-cy]="'bets-ticket-remove-' + eIdx + '-' + rIdx + '-' + tIdx"
                        >
                          {{ 'generic.remove' | translate: 'Remove' }}
                        </button>
                        <button
                          type="button"
                          class="
                            bets-btn
                            bets-btn--submit
                            tw-inline-flex
                            tw-items-center
                            tw-justify-center
                            tw-border-0
                            tw-rounded-[4px]
                            tw-text-[11px]
                            tw-font-semibold
                            tw-tracking-[0.2px]
                            tw-py-[4px]
                            tw-cursor-pointer
                            tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                            tw-whitespace-nowrap
                            tw-w-[80px]
                            tw-h-[26px]
                            tw-flex-[0_0_80px]
                            tw-text-[#FFFFFF]
                          "
                          (click)="confirmBet('submit-saved-bet', 'ticket', ticket)"
                          [attr.data-cy]="'bets-ticket-submit-' + eIdx + '-' + rIdx + '-' + tIdx"
                        >
                          {{ 'generic.submit' | translate: 'Submit' }}
                        </button>
                      } @else if (currentTab === 'active') {
                        <button
                          type="button"
                          class="
                            bets-btn
                            bets-btn--remove
                            tw-inline-flex
                            tw-items-center
                            tw-justify-center
                            tw-border-0
                            tw-rounded-[4px]
                            tw-text-[11px]
                            tw-font-semibold
                            tw-tracking-[0.2px]
                            tw-py-[4px]
                            tw-cursor-pointer
                            tw-transition-colors tw-duration-[120ms] tw-ease-in-out
                            tw-whitespace-nowrap
                            tw-w-[80px]
                            tw-h-[26px]
                            tw-flex-[0_0_80px]
                            tw-text-[#FFFFFF]
                          "
                          (click)="confirmCancelBet(ticket)"
                          [disabled]="ticket.IsCancelled || isProcessing"
                          [class.bets-btn--cancelled]="ticket.IsCancelled"
                          [attr.data-cy]="'bets-ticket-cancel-' + eIdx + '-' + rIdx + '-' + tIdx"
                        >
                          {{ ticket.IsCancelled ? 'Cancelled' : 'Cancel' }}
                        </button>
                      }
                    </div>
                  </div>
                </ng-container>
              }
            </ng-container>
          }
        </ng-container>
        </div>
      }

    </div>
  </div>
</div>
